import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { API_URL } from '../../api';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Geolocation utility
export interface LocationData {
  country: string;
  currency: string;
  countryName: string;
}

export const detectUserLocation = async (): Promise<LocationData> => {
  try {
    // Server-seitiger Proxy, um CORS zu vermeiden.
    // Basis-URL kommt aus api.ts statt aus einer weiteren Kopie der Logik.
    const response = await fetch(`${API_URL}/api/geolocation`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
      signal: AbortSignal.timeout(5000)
    });
    
    if (!response.ok) {
      throw new Error(`Geolocation proxy failed: ${response.status}`);
    }
    
    const data = await response.json();
    
    return {
      country: data.country,
      currency: data.currency,
      countryName: data.countryName
    };
  } catch (error) {
    console.log('Geolocation failed, using default:', error);
  }

  // Fallback to default location (Switzerland)
  return getDefaultLocation();
};

const getDefaultLocation = (): LocationData => ({
  country: 'CH',
  currency: 'CHF',
  countryName: 'Schweiz'
});
